import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';
import FlarePage from './FlarePage';
import PhotoGallery from './PhotoGallery';
import reportWebVitals from './reportWebVitals';

const isFlarePage = /^\/flare\/?$/i.test(window.location.pathname);
const RootApp = window.location.hostname === 'photos.have-fun.engineering'
  ? PhotoGallery
  : isFlarePage ? FlarePage : App;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);

reportWebVitals();
